export const TRANSLATIONS_FR = {
  academie: "academie",
  usage: "usage",
  service: "network",
  planification: "planification",
  rapport: "Rapports",
};
